import { useAuth } from "../context/AuthContext";
import { Navigate } from "react-router";

export default function ProtectedRoute({children}) {
    const {user} = useAuth();
    return user ? children : <Navigate to='/admin/login' />
}